module.exports = __webpack_public_path__ + "img/kehu_dawo.9630f0a5.png";